import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-select-multiple-data',
  templateUrl: './select-multiple-data.component.html',
  styleUrl: './select-multiple-data.component.scss',
})
export class SelectMultipleDataComponent {
  @Input() label: string = 'PLACEHOLDER.CHONMUC';
  @Input() options: any[] = [];
  @Input() labelKey: string = 'name';
  @Input() valueKey: string = 'id';
  @Input() control: FormControl = new FormControl([]);
  @Output() selectionChange = new EventEmitter<any[]>();
  @Input() compareFn = (o1: any, o2: any) => {
    if (!o1 || !o2) return false;
    return (o1.id === o2.id) || (o1.Id === o2.Id);
  };
  @Input() errorMessage: string = '';    
  @Input() isSubmit: boolean = false;
  ngOnInit() {
    this.control.valueChanges.subscribe((value) => {
      this.selectionChange.emit(value);
    });
  }
}
